import React from 'react';

import type { ILead } from 'src/services/api';
import ExpandableItem from 'src/components/lead-sidebar/LeadSidebarExpandableItem';
import { FlexColumn } from 'src/components/flex';
import FactRow from 'src/components/lead-sidebar/FactRow';
import SmartFieldsList from 'src/components/lead-sidebar/SmartFieldsList';
import EditFactButton from 'src/components/lead-sidebar/EditFactButton';
import { useJustAddedKeys } from 'src/components/lead-sidebar/just-added-facts-context';

type Props = {
    lead: ILead;
    validSmartFields: [string, string | Record<string, string>][];
};

export default function LeadInfo({ lead, validSmartFields }: Props) {
    const displayedUUID = lead.uuid.slice(0, 10) + '...';
    const hasSmartFields = validSmartFields.length > 0;

    const justAddedKeys = useJustAddedKeys();

    return (
        <ExpandableItem title="Lead Info" defaultExpanded={hasSmartFields || !!lead.phone_number || !!lead.email}>
            <FlexColumn rowGap={1.5} pb={1}>
                {lead.phone_number && (
                    <FactRow
                        label="Phone"
                        value={lead.phone_number}
                        factKey="phone"
                        isJustAdded={justAddedKeys.has('phone')}
                        editButton={
                            <EditFactButton
                                leadUuid={lead.uuid}
                                title="Phone"
                                testId="phone_number"
                                fields={[{ key: 'phone_number', value: lead.phone_number }]}
                            />
                        }
                    />
                )}
                {lead.email && (
                    <FactRow
                        label="Email"
                        value={lead.email}
                        factKey="email"
                        isJustAdded={justAddedKeys.has('email')}
                        editButton={
                            <EditFactButton
                                leadUuid={lead.uuid}
                                title="Email"
                                testId="email"
                                fields={[{ key: 'email', value: lead.email }]}
                            />
                        }
                    />
                )}
                <SmartFieldsList lead={lead} validSmartFields={validSmartFields} />
                <FactRow
                    label="Reffie ID"
                    value={displayedUUID}
                    copyText={lead.uuid}
                    factKey="reffie-id"
                />
            </FlexColumn>
        </ExpandableItem>
    );
}
